import PropTypes from 'prop-types';

const customPropTypes = {
  formContext: PropTypes.shape({
    register: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    getValues: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
  }),
};

export default customPropTypes;
